export function isSessionStorageAvailable() {
  try {
    const testKey = '__test__';
    sessionStorage.setItem(testKey, '1');
    sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
}
